/**
 * Auswahlfeld „Geburtsland" — EIN Baustein für Onboarding, Nutzerverwaltung
 * und „Kunde anlegen". (24.09.2026, Ticket 2567, Onboarding-Plan Stufe 0b)
 *
 * Das Land bestimmt die Zeitzone des Human-Design-Charts
 * (shared/geburtsland.ts). Ein Ort als Freitext tat das nie — dort stand
 * immer Wien. Der Wert des Feldes ist der Schlüssel („AT", „US-OST"), den
 * der Server speichert.
 *
 * Aussehen: der Aufrufer gibt die Klasse seines Formulars mit (`onb-input`,
 * `usr-input`) — das Feld sieht dann aus wie seine Nachbarn. Kein eigenes CSS.
 */
import {
  VORGABE_GEBURTSLAND,
  geburtslaenderSortiert,
  geburtslandName,
  geburtslandVon,
} from "../../shared/geburtsland.js";

export function baueGeburtslandAuswahl(opts: {
  /** Gespeicherter Schlüssel; leer/unbekannt → Österreich. */
  wert?: string | null;
  klasse: string;
  /** Für Formulare ohne sichtbare Beschriftung (Onboarding). */
  ariaLabel?: string;
}): HTMLSelectElement {
  const sel = document.createElement("select");
  sel.className = opts.klasse;
  sel.name = "birthCountry";
  if (opts.ariaLabel) sel.setAttribute("aria-label", opts.ariaLabel);
  for (const g of geburtslaenderSortiert()) {
    const o = document.createElement("option");
    o.value = g.schluessel;
    o.textContent = geburtslandName(g);
    sel.appendChild(o);
  }
  sel.value = geburtslandVon(opts.wert)?.schluessel ?? VORGABE_GEBURTSLAND;
  return sel;
}

/**
 * Das Feld samt Beschriftung im Raster der Admin-Formulare (`usr-field`) —
 * „Neuer Nutzer", „Bearbeiten" und „Kunde anlegen" bauen es gleich.
 */
export function geburtslandFeldImRaster(
  raster: HTMLElement,
  wert?: string | null,
): HTMLSelectElement {
  const feld = document.createElement("label");
  feld.className = "usr-field";
  const etikett = document.createElement("span");
  etikett.className = "usr-field-label";
  etikett.textContent = "Geburtsland";
  const sel = baueGeburtslandAuswahl({ wert, klasse: "usr-input" });
  feld.append(etikett, sel);
  raster.appendChild(feld);
  return sel;
}

/** Lesbarer Name zu einem gespeicherten Schlüssel; "" ohne gültigen. */
export function geburtslandAnzeige(schluessel: string | null | undefined): string {
  const g = geburtslandVon(schluessel);
  return g ? geburtslandName(g) : "";
}
